@if (showComplianceInfo) {
    <div class="card panel-flat-color secondary-panel">
        <div class="panel-flat-header pointer" (click)="expandOrCollapse()">
            <panel-chevron [showBody]="showBody"></panel-chevron>
            <h3>Assets</h3>
        </div>
        @if (showBody) {
            <div class="card-body" style="padding-top: 0;height: 490px;">
                @if (onLoading) {
                    <div class="text-center" style="margin-top: 50px;">
                        <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
                    </div>
                }
                <div [hidden]="onLoading" class="ws-flex-container-horizontal ws-stretch ws-overflow-auto">
                    <asset-list [companyIdFilter]="companyId"
                                [parcelIdFilter]="parcelId"
                                [siteIdFilter]="siteId"
                                [isEmbeddedMode]="true"
                                [(loading)]="onLoading"></asset-list>
                </div>
            </div>
        }
    </div>
}
